import { FC } from "react";

import { Box, Stack } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { FullWidthVStack } from "@components/common";
import Icon from "@components/Icon";
import Link from "@components/Link";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { DeliveryMethod } from "../../constants";
import type { TPaymentStatus } from "../../types";

type TOrderDescriptionProps = {
  paymentStatus: TPaymentStatus;
  onDownloadLabel: () => void;
};

const OrderDescription: FC<TOrderDescriptionProps> = ({ paymentStatus, onDownloadLabel }) => {
  const { t } = useTranslation();

  const { deliveryMethod, willCustomerPrintLabel } = paymentStatus;

  const isLockerDeliveryMethod =
    deliveryMethod === DeliveryMethod.PudoToPudo || deliveryMethod === DeliveryMethod.PudoToDoor;

  const getOrderDescriptionSteps = (): string => {
    if (isLockerDeliveryMethod) {
      return t("order-success-locker_steps");
    }
    if (willCustomerPrintLabel) {
      return t("order-success-door_print_label_steps");
    }
    return t("order-success-door_steps");
  };

  return (
    <FullWidthVStack spacing={responsiveStyle({ mobile: "1rem", desktop: "0.5rem" })}>
      <Box fontSize="1.125rem" px={responsiveStyle({ mobile: "0.5rem", desktop: "0" })} lineHeight="1.2">
        {t("order-success-information_sent_by_email")}
      </Box>
      <Stack direction={responsiveStyle({ mobile: "column", desktop: "row" })} align="start" spacing="1.5rem">
        <Box flex="1" px={responsiveStyle({ mobile: "0.5rem", desktop: "0" })}>
          <Box>{t("order-success-next_steps")}</Box>
          <Box fontWeight="300" whiteSpace="pre-line">
            {getOrderDescriptionSteps()}
          </Box>
        </Box>
        {(willCustomerPrintLabel || isLockerDeliveryMethod) && (
          <Box>
            <Link
              variant="dark"
              leftIcon={<Icon icon="download" size="1.25rem" />}
              label={t("order-success-download_label")}
              id="order-success-download_label"
              onClick={onDownloadLabel}
              sx={{ fontSize: responsiveStyle({ mobile: "0.875rem", desktop: "1rem" }) }}
            />
          </Box>
        )}
      </Stack>
    </FullWidthVStack>
  );
};
export default OrderDescription;
